import {postBonusesReferralIssue} from '../api/postBonusesReferralIssue';

const setPostBonusesReferralIssue = (params) => {
    return async (dispatch, getState) => {
        try {
            await postBonusesReferralIssue(params);     
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostBonusesReferralIssue
}